import React, { useState } from "react";
import CustomTabs from "components/tabs/customTab";
import AllDocuments from "./AllDocuments";
import ContractsDocument from "./Contracts";
import PromotionsDocument from "./Promotions";
import CompensationDocument from "./Compensation";

const EmployeeDocumentsTabs = () => {
    const [activeTab, setActiveTab] = useState("All Documents");
    
    const TabLabel = ({ text }) => (
        <div className="flex items-center justify-center gap-2">
            <span className="text-sm font-medium">{text}</span>
        </div>
    );

    const tabOptions = [
        { label: <TabLabel text="All Documents" />, value: "All Documents" },
        { label: <TabLabel text="Contracts" />, value: "Contracts" },
        { label: <TabLabel text="Promotions" />, value: "Promotions" },
        { label: <TabLabel text="Compensation" />, value: "Compensation" },
    ];

    return (
        <div className="flex flex-col gap-2 w-full">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
                height="h-10"
            />

            <div className="flex flex-col outline-none space-y-4 mt-6">
                {activeTab === "All Documents" && (
                    <>
                        <AllDocuments />
                    </>
                )}

                {activeTab === "Contracts" && (
                    <>
                        <ContractsDocument />
                    </>
                )}

                {activeTab === "Promotions" && (
                    <>
                        <PromotionsDocument />
                    </>
                )}

                {activeTab === "Compensation" && (
                    <>
                        <CompensationDocument />
                    </>
                )}
            </div>
        </div>
    );
};

export default EmployeeDocumentsTabs;
